import { __makeTemplateObject } from 'tslib';
import React__default, { useState } from 'react';
import styled from 'styled-components';

var StyledTooltipWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ToolTip__StyledTooltipWrapper",
  componentId: "sc-14icby9-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n"], ["\n  display: inline-block;\n  position: relative;\n"])));
var StyledTooltipTip = /*#__PURE__*/styled.div.withConfig({
  displayName: "ToolTip__StyledTooltipTip",
  componentId: "sc-14icby9-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  border-radius: 4px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: ", ";\n  color: ", ";\n  background: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  line-height: ", ";\n  z-index: 100;\n  text-align: ", ";\n  width: ", ";\n\n  :before {\n    content: \" \";\n    left: 50%;\n    border: solid transparent;\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border-width: 6px;\n    margin-left: calc(6px * -1);\n  }\n\n  &.top {\n    bottom: calc(100% + 5px);\n\n    &:before {\n      bottom: -12px;\n      border-top-color: ", ";\n    }\n  }\n\n  &.right {\n    right: auto;\n    left: calc(100% + 30px);\n    top: 50%;\n    transform: translateX(0) translateY(-50%);\n\n    &:before {\n      left: calc(6px * -1);\n      top: 50%;\n      transform: translateX(0) translateY(-50%);\n      border-right-color: ", ";\n    }\n  }\n\n  &.bottom {\n    &:before {\n      bottom: 100%;\n      border-bottom-color: ", ";\n    }\n  }\n\n  &.left {\n    left: auto;\n    right: calc(100% + 10px);\n    top: 50%;\n    transform: translateX(0) translateY(-50%);\n\n    &:before {\n      left: auto;\n      right: calc(6px * -2);\n      top: 50%;\n      transform: translateX(0) translateY(-50%);\n      border-left-color: ", ";\n    }\n  }\n\n  ul {\n    margin: 3px;\n    li {\n      font-size: 12px;\n      padding-bottom: 2px;\n      &:last-child {\n        padding-bottom: 0;\n      }\n    }\n  }\n"], ["\n  position: absolute;\n  border-radius: 4px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: ", ";\n  color: ", ";\n  background: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  line-height: ", ";\n  z-index: 100;\n  text-align: ", ";\n  width: ", ";\n\n  :before {\n    content: \" \";\n    left: 50%;\n    border: solid transparent;\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border-width: 6px;\n    margin-left: calc(6px * -1);\n  }\n\n  &.top {\n    bottom: calc(100% + 5px);\n\n    &:before {\n      bottom: -12px;\n      border-top-color: ", ";\n    }\n  }\n\n  &.right {\n    right: auto;\n    left: calc(100% + 30px);\n    top: 50%;\n    transform: translateX(0) translateY(-50%);\n\n    &:before {\n      left: calc(6px * -1);\n      top: 50%;\n      transform: translateX(0) translateY(-50%);\n      border-right-color: ", ";\n    }\n  }\n\n  &.bottom {\n    &:before {\n      bottom: 100%;\n      border-bottom-color: ", ";\n    }\n  }\n\n  &.left {\n    left: auto;\n    right: calc(100% + 10px);\n    top: 50%;\n    transform: translateX(0) translateY(-50%);\n\n    &:before {\n      left: auto;\n      right: calc(6px * -2);\n      top: 50%;\n      transform: translateX(0) translateY(-50%);\n      border-left-color: ", ";\n    }\n  }\n\n  ul {\n    margin: 3px;\n    li {\n      font-size: 12px;\n      padding-bottom: 2px;\n      &:last-child {\n        padding-bottom: 0;\n      }\n    }\n  }\n"])), function (_a) {
  var padding = _a.padding;
  return padding || "6px";
}, function (_a) {
  var color = _a.color;
  return color || "white";
}, function (_a) {
  var backgroundColor = _a.backgroundColor;
  return backgroundColor || "black";
}, function (_a) {
  var fontSize = _a.fontSize;
  return fontSize || "14px";
}, function (_a) {
  var fontFamily = _a.fontFamily;
  return fontFamily || "Graphik, sans-serif";
}, function (_a) {
  var lineHeight = _a.lineHeight;
  return lineHeight || "1";
}, function (_a) {
  var textAlign = _a.textAlign;
  return textAlign || "center";
}, function (_a) {
  var width = _a.width;
  return width || "auto";
}, function (_a) {
  var backgroundColor = _a.backgroundColor;
  return backgroundColor || "black";
}, function (_a) {
  var backgroundColor = _a.backgroundColor;
  return backgroundColor || "black";
}, function (_a) {
  var backgroundColor = _a.backgroundColor;
  return backgroundColor || "black";
}, function (_a) {
  var backgroundColor = _a.backgroundColor;
  return backgroundColor || "black";
});
var Tooltip = function (props) {
  var timeout;
  var _a = useState(false),
    active = _a[0],
    setActive = _a[1];
  var showTip = function () {
    timeout = setTimeout(function () {
      setActive(true);
    }, props.delay || 400);
  };
  var hideTip = function () {
    clearInterval(timeout);
    setActive(false);
  };
  return React__default.createElement(StyledTooltipWrapper, {
    onMouseEnter: showTip,
    onMouseLeave: hideTip
  }, props.children, active && React__default.createElement(StyledTooltipTip, {
    className: props.direction,
    style: props.styles
  }, props.content));
};
var templateObject_1, templateObject_2;

export { Tooltip };
//# sourceMappingURL=ToolTip.js.map
